import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import cn from 'classnames';
import { useDevice } from '../Device';
import { PageHeader } from '../PageHeader';
import styles from './Page.module.scss';
import { GetPageTID } from './Page.utils';
import { PageContentHeaderContext } from './PageContentHeader';
/** Renders a page to the right of a sidebar. */ export const Page = /*#__PURE__*/ React.forwardRef(function Page(props, ref) {
    const { children, className, header, subheader, actions, loading, style, height, width, minWidth, maxWidth, disableRightGutter, disableLeftGutter, skin = 'primary', variant = 'default', onClickBack, testId, hideActionsOnMobile, hideSubheaderOnMobile, onScroll } = props, rest = _object_without_properties(props, [
        "children",
        "className",
        "header",
        "subheader",
        "actions",
        "loading",
        "style",
        "height",
        "width",
        "minWidth",
        "maxWidth",
        "disableRightGutter",
        "disableLeftGutter",
        "skin",
        "variant",
        "onClickBack",
        "testId",
        "hideActionsOnMobile",
        "hideSubheaderOnMobile",
        "onScroll"
    ]);
    const { isMobileDevice } = useDevice();
    const [isScrolled, setIsScrolled] = useState(false);
    const [contentHeaderEl, setContentHeaderEl] = useState(null);
    const { PageTestIds } = useMemo(()=>GetPageTID(testId), [
        testId
    ]);
    const renderedStyle = useMemo(()=>_object_spread_props(_object_spread({}, style), {
            '--pageHeight': height,
            width: isMobileDevice ? undefined : width,
            '--min-width': isMobileDevice ? undefined : minWidth,
            '--max-width': isMobileDevice ? undefined : maxWidth
        }), [
        style,
        height,
        width,
        minWidth,
        maxWidth,
        isMobileDevice
    ]);
    function handleScroll(e) {
        setIsScrolled(e.currentTarget.scrollTop > 0);
        onScroll === null || onScroll === void 0 ? void 0 : onScroll(e);
    }
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, rest, testId != null ? {
        'data-testid': testId
    } : {}), {
        className: cn(styles.root, styles["".concat(skin, "Skin")], {
            [styles.disableRightGutter]: disableRightGutter,
            [styles.disableLeftGutter]: disableLeftGutter,
            [styles.containedHeight]: variant === 'containedHeight',
            [styles.mobile]: isMobileDevice
        }, className),
        style: renderedStyle,
        ref: ref,
        onScroll: handleScroll,
        children: [
            /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
                className: cn(styles.stickyToTop, {
                    [styles.isScrolled]: isScrolled
                })
            }, testId != null ? {
                'data-testid': PageTestIds.StickyHeader()
            } : {}), {
                children: [
                    header && /*#__PURE__*/ _jsx(PageHeader, {
                        title: header,
                        loading: loading,
                        subheader: hideSubheaderOnMobile && isMobileDevice ? undefined : subheader,
                        actions: actions,
                        hideActions: hideActionsOnMobile && isMobileDevice,
                        onClickBack: onClickBack,
                        testId: testId
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(isMobileDevice && styles.contentHeader),
                        ref: setContentHeaderEl
                    })
                ]
            })),
            /*#__PURE__*/ _jsx("div", {
                className: styles.content,
                "data-testid": testId && "".concat(testId, "-page-content"),
                children: /*#__PURE__*/ _jsx(PageContentHeaderContext.Provider, {
                    value: contentHeaderEl,
                    children: children
                })
            })
        ]
    }));
});
